import browser from 'webextension-polyfill'

import { NetworkId } from '@/shared/models/Network'
import {
  DEFAULT_NATIVE_TOKEN_SYMBOL,
  NATIVE_TOKEN_SYMBOLS,
} from '@/shared/config'

export const NETWORK_ID = 'networkId'
export const PREVIOUS_NETWORK_ID = 'previousNetworkId'
export const LUKSO_MAINNET_ID = 'mainnet'
export const LUKSO_TESTNET_ID = 'testnet'
export const DEFAULT_NETWORK = LUKSO_MAINNET_ID
export const LUKSO_MAINNET_CHAIN_ID = 42
export const DEFAULT_CHAIN_ID = LUKSO_MAINNET_CHAIN_ID
export const LUKSO_TESTNET_CHAIN_ID = 4201

export const getStoredNetworkId = async (): Promise<string | undefined> => {
  const { networkId } = await browser.storage.local.get(NETWORK_ID)
  return networkId
}

export const setNetwork = async (networkId: NetworkId): Promise<void> => {
  const previousNetwork = await getStoredNetworkId()
  await setPreviousNetwork(previousNetwork || DEFAULT_NETWORK)
  await browser.storage.local.set({ networkId })
}

export const getPreviousNetwork = async (): Promise<string> => {
  const { previousNetworkId } =
    await browser.storage.local.get(PREVIOUS_NETWORK_ID)
  return previousNetworkId
}

export const setPreviousNetwork = async (
  previousNetworkId: string
): Promise<void> => {
  await browser.storage.local.set({ previousNetworkId })
}

/**
 * Chain ID is mapped to chain's native token symbol.
 *
 * @param chainId optional chain ID number which if not provided is defaulted to @see DEFAULT_CHAIN_ID
 * @returns chain's native token symbol or @see DEFAULT_NATIVE_TOKEN_SYMBOL as default
 */
export const getNetworkNativeTokenSymbol = async (
  chainId?: number
): Promise<string> => {
  return (
    NATIVE_TOKEN_SYMBOLS.get(chainId ?? DEFAULT_CHAIN_ID) ||
    DEFAULT_NATIVE_TOKEN_SYMBOL
  )
}
